import { render, staticRenderFns } from "./activity-card.vue?vue&type=template&id=19de2386&scoped=true"
import script from "./activity-card.vue?vue&type=script&lang=js"
export * from "./activity-card.vue?vue&type=script&lang=js"
import style0 from "./activity-card.vue?vue&type=style&index=0&id=19de2386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19de2386",
  null
  
)

export default component.exports